module.exports = __webpack_public_path__ + "resources/img/img_edb_2.f57350673ee7529416697876d878e8a6.png";